// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import LabeledCriteria from '../../../../shared/components/labeled-criteria';
import {privatize} from '../../../../shared/components/privacy-wrapper';

const CreditMemoInvoiceRequestCriteria = props =>
    <div className='credit-memo-invoice-request-criteria'>
        <LabeledCriteria
            className='invoice-request-criteria'
            isRequired={false}
            label='INVOICE_REQUEST'
            maxLength='17'
            onInputChange={props.handleInvoiceRequestInputChange}
            placeholder='INVOICE_REQUEST'
            type='text'
            value={props.invoiceRequest}
        />
    </div>;

CreditMemoInvoiceRequestCriteria.displayName = 'CreditMemoInvoiceRequestCriteria';
CreditMemoInvoiceRequestCriteria.propTypes = {
    handleInvoiceRequestInputChange: PropTypes.func.isRequired,
    invoiceRequest: PropTypes.string.isRequired
};

export default privatize('cmInvoiceRequestNotAllowed')(CreditMemoInvoiceRequestCriteria);




// WEBPACK FOOTER //
// ./src/reports/credit-memo/components/credit-memo-report-criteria/invoice-request-criteria.js